// extracted by mini-css-extract-plugin
export var button = "landingpage-module--button--3zd7J";